module.exports = __webpack_public_path__ + "static/media/pt.89e77e30.svg";